// /tickets/resolutions — browse + link resolution tickets.
// Data source: GET /rest/v1/v_resolutions via fetchResolutions().
// Route also covers /improvements + /edit-requests sub-pages.

import { pageBoilerplateFetch } from '../../functions/tickets/ticketUtils.js'
import { fetchResolutions } from '../../functions/tickets/fetchResolutions.js'

export const resolutions = {
  extends: 'AppPage',
  metadata: { title: 'Resolutions / Tickets / Symbols Workspace' },
  fetch: pageBoilerplateFetch,

  onCreate: async (el, s) => {
    // Clear any stale filter state AND stale modal state from a prior visit.
    // Clearing selectedTicket here (in addition to onRemove) is belt-and-suspenders:
    // onRemove on the departing page handles the navigation case; this guard covers
    // any edge case where selectedTicket is truthy on first render (e.g. deep-link
    // URL without ?ticket= param, or a hot-reload that preserves stale state).
    // Without this clear, TicketsDetailModal.display returns 'flex' immediately and
    // renders a full-viewport black overlay (pointer-events:auto) that blocks all
    // page chrome (org switcher, profile menu, CreateTicket, sidebar nav).
    s.root.update({ selectedTicket: null, ticketDraft: null, ticketEditMode: false, resolutions: null, resFilterQuery: null, resFilterAgent: null, resFilterDate: null })
    const data = await fetchResolutions({ limit: 100 })
    s.root.update({ resolutions: data })
  },

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  TicketsResolutionsMain: {},
  TicketsDetailModal: {}
}

export const resolutionsEditRequests = {
  extends: 'AppPage',
  metadata: { title: 'Edit requests / Resolutions / Symbols Workspace' },
  fetch: pageBoilerplateFetch,

  onCreate: (el, s) => {
    s.root.update({ selectedTicket: null, ticketDraft: null, ticketEditMode: false })
  },

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  ResolutionsEditRequestsMain: {},
  TicketsDetailModal: {}
}

export const resolutionsImprovements = {
  extends: 'AppPage',
  metadata: { title: 'Improvements / Resolutions / Symbols Workspace' },
  fetch: pageBoilerplateFetch,

  onCreate: (el, s) => {
    s.root.update({ selectedTicket: null, ticketDraft: null, ticketEditMode: false })
  },

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  ResolutionsImprovementsMain: {},
  TicketsDetailModal: {}
}
